import { ServicesTableFilters } from "../components/Services/tables/ServicesTable";

/** YYYY-MM-DD: día actual (referencia local). */
export function getGeneralModeDefaultStartDateYmd(reference = new Date()): string {
  const year = reference.getFullYear();
  const month = String(reference.getMonth() + 1).padStart(2, "0");
  const day = String(reference.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Aplica el rango por defecto del modo general si falta fecha desde. */
export function applyGeneralModeDateDefaults(
  filters: ServicesTableFilters
): ServicesTableFilters {
  if (!filters.generalMode) return filters;
  if (String(filters.fechaDesde ?? "").trim()) return filters;

  return {
    ...filters,
    fechaDesde: getGeneralModeDefaultStartDateYmd(),
    fechaHasta: "",
    horaDesde: "",
    horaHasta: "",
  };
}
